import { Link } from 'react-router-dom'
import {Home, Phone} from 'lucide-react'

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-5 py-16 text-center">
      <div className="text-7xl lg:text-9xl font-extrabold text-urgent-500/20">404</div>
      <h1 className="mt-2 text-3xl lg:text-4xl font-extrabold text-navy-700">Page introuvable</h1>
      <p className="mt-3 text-navy-500 max-w-md">La page que vous cherchez n'existe pas ou a été déplacée.</p>
      <div className="mt-7 flex flex-col sm:flex-row gap-3">
        <Link to="/" className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl gradient-urgent text-white font-bold shadow-orange-glow">
          <Home className="w-4 h-4" /> Retour à l'accueil
        </Link>
        <a href="tel:+41796430399" className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-navy-700 text-white font-bold">
          <Phone className="w-4 h-4" /> Nous appeler
        </a>
      </div>
    </div>
  )
}
